import Typography from "@material-ui/core/Typography";

interface ITermsAndPolicyContent {
    companyName: string;
    language: string;
    buttonText: string;
    companyPrivacyPolicyUrl?: string;
}

const TermsAndPolicyContent = ({
    companyName,
    language,
    buttonText,
    companyPrivacyPolicyUrl,
}: ITermsAndPolicyContent) => {
    const linkCompleoTerms = (
        <a
            target="_blank"
            href="https://ats.compleo.com.br/TermosServicoCandidato"
            rel="noreferrer"
        >
            {language === "pt-BR" ? "termos de uso" : "terms and conditions"}
        </a>
    );

    const linkCompleoPrivacyPolicy = (
        <a
            target="_blank"
            href="https://ats.compleo.com.br/PoliticaPrivacidade"
            rel="noreferrer"
        >
            {language === "pt-BR"
                ? "política de privacidade"
                : "privacy policy"}
        </a>
    );

    const linkCompanyPrivacyPolicy = companyPrivacyPolicyUrl ? (
        <a href={companyPrivacyPolicyUrl} target="_blank" rel="noreferrer">
            {language === "pt-BR"
                ? "política de privacidade"
                : "privacy policy"}
        </a>
    ) : null;

    if (language === "pt-BR") {
        return (
            <>
                <Typography variant="body2" style={{ paddingBottom: "5px" }}>
                    {`Você está em uma área do site da empresa ${companyName} fornecida pela plataforma Compleo.`}
                </Typography>
                <Typography variant="body2">
                    {companyPrivacyPolicyUrl ? (
                        <>
                            {`Ao clicar no botão ${buttonText} você CONCORDA com a) `}
                            {linkCompleoTerms} e a {linkCompleoPrivacyPolicy} do
                            Compleo e b) {linkCompanyPrivacyPolicy}{" "}
                            {` da empresa ${companyName}.`}
                        </>
                    ) : (
                        <>
                            {`Ao clicar no botão ${buttonText} você CONCORDA com os `}
                            {linkCompleoTerms} e a {linkCompleoPrivacyPolicy} do
                            Compleo.
                        </>
                    )}
                </Typography>
            </>
        );
    } else {
        return (
            <>
                <Typography variant="body2" style={{ paddingBottom: "5px" }}>
                    {`The website you have entered is owned by ${companyName} and is operated by Compleo ATS.`}
                </Typography>
                <Typography variant="body2">
                    {companyPrivacyPolicyUrl ? (
                        <>
                            {`By clicking ${buttonText} you agree to a) `}
                            {`Compleo's `} {linkCompleoTerms} and{" "}
                            {linkCompleoPrivacyPolicy}. b) {`${companyName}'s`}{" "}
                            {linkCompanyPrivacyPolicy}.
                        </>
                    ) : (
                        <>
                            {`By clicking ${buttonText} you agree to Compleo's `}{" "}
                            {linkCompleoTerms} and {linkCompleoPrivacyPolicy}.
                        </>
                    )}
                </Typography>
            </>
        );
    }
};

export default TermsAndPolicyContent;
